import {
  SEND_PAYMENT_REMINDER_LOADING,
  SEND_PAYMENT_REMINDER_SUCCESS,
  SEND_PAYMENT_REMINDER_FAILED,
} from "../types";

interface PaymentReminderState {
  loading: boolean;
  success: boolean;
  error: string | null;
}

const initialState: PaymentReminderState = {
  loading: false,
  success: false,
  error: null,
};

export default function paymentReminderReducer(
  state = initialState,
  action: any
): PaymentReminderState {
  switch (action.type) {
    case SEND_PAYMENT_REMINDER_LOADING:
      return { ...state, loading: action.loading, success: false, error: null };
    case SEND_PAYMENT_REMINDER_SUCCESS:
      return { ...state, loading: false, success: true, error: null };
    case SEND_PAYMENT_REMINDER_FAILED:
      return { ...state, loading: false, success: false, error: action.error };
    default:
      return state;
  }
}
